import { makeAutoObservable, runInAction } from 'mobx';
import { notificationService } from '../services/notificationService';
import type { NotificationHistory } from '../types';

class NotificationStore {
  notifications: NotificationHistory[] = [];
  isLoading = false;
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchRecentNotifications(limit: number = 20) {
    this.isLoading = true;
    this.error = null;

    try {
      const response = await notificationService.getRecentNotifications({ limit });

      runInAction(() => {
        this.notifications = response.data || [];
      });
    } catch (error: any) {
      runInAction(() => {
        this.error = error.message || '通知履歴の取得に失敗しました';
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  async fetchNotificationsByLineUserId(lineUserId: string, params?: {
    from?: string;
    to?: string;
    limit?: number;
  }) {
    this.isLoading = true;
    this.error = null;

    try {
      const response = await notificationService.getNotificationsByLineUserId(lineUserId, params);

      runInAction(() => {
        this.notifications = response.data || [];
      });
    } catch (error: any) {
      runInAction(() => {
        this.error = error.message || '通知履歴の取得に失敗しました';
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  get recentNotifications() {
    return this.notifications.slice(0, 20);
  }

  getNotificationTypeLabel(type: string): string {
    switch (type) {
      case 'calling':
        return '呼び出し';
      case 'waiting':
        return '待機';
      default:
        return type;
    }
  }

  getContextLabel(context: string): string {
    if (context.includes('診察')) return '診察';
    if (context.includes('会計')) return '会計';
    if (context.includes('検査')) return '検査';
    if (context.includes('薬')) return '薬局';
    return context;
  }
}

export const notificationStore = new NotificationStore();